import { checkResponse } from "src/components/js/statics1";

export default class stepLogMessageClass {
  constructor(stepLogId) {
    this.stepLogId = stepLogId;
    this.entryTime;
    this.message;
    this.keikkaId;
    this.varmenne;
    this.stepLogTypeId = 0;
    this.keikkaTilaId = -1;
    this.creatorPersonId; // person who created stepLog message
    this.data = null;

    // confirmations
    // message can be and will be confirmed if keikkaData.auth.tyomaa.createKeikka==true
    this.isConfirmed = false; // initially confirmed or not
    this.confirmDate = null; // time of confirmation
    this.requireConfirm = false; // does the message require confirmation, ALL requireConfirms MUST BE confirmed for keikka
    this.autoConfirm = false; // does the message autoconfirm when read
    // https://betoni.online/cc/{confirmCode}
    // http://betoni.online/....?cc={confirmCode}
    this.confirmCode;

    this.keikkaData; // the keikkaData (keikkaClass), which is stringifyed to DB

    this.isSystemMessage = false; // if true, message is only shown to isKeikkaAdmin members
    this.addMessageOnlyIfVarmenneChanged = false;
  }

  async saveToDB(socket, emitUpdateToClients = true) {
    if (socket == null) {
      console.log("socket is null at stepLogMessageClass.saveToDB, cannot create stepLog message");
      console.trace();
      return;
    }
    socket.emit("stepLog:newMessage", this, emitUpdateToClients);
  }
}
export async function fetchStepLogMessage_not_used(stepLogId, token) {
  const addr = "/api/stepLog/get/" + stepLogId;
  const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, {
    method: "GET",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  });
  return (await checkResponse(response, "stepLogMessageClass.fetchStepLogMessage")).data;
}
export async function confirmStepLog(stepLogId, keikkaId, socket) {
  await socket.emit("stepLog:doConfirm", stepLogId, keikkaId);
}

export async function confirmStepLogType(keikkaId, stepLogTypeId, socket, emitUpdate = true) {
  if (keikkaId == null || stepLogTypeId == null) {
    console.log("ERROR in confirmStepLogType: keikkaId or stepLogTypeId is null");
    return;
  }
  await socket.emit("stepLog:doConfirmType", keikkaId, stepLogTypeId, emitUpdate);
}

export async function confirmStepLogCode(confirmCode) {
  // send get message fetch to server
  const addr = "/api/stepLog/doConfirmCode/" + confirmCode;
  const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }).catch((err) => {
    console.log("stepLogMessageClass.doConfirmCode fetch error: " + err);
  });
  return (await checkResponse(response, "stepLogMessageClass.fetchStepLogMessage")).data;
}

export function newStepLogMessage(message, creatorPersonId, keikkaData, stepLogTypeId, data) {
  const msg = new stepLogMessageClass(null);
  msg.message = message;
  msg.creatorPersonId = creatorPersonId;
  msg.keikkaTilaId =
    keikkaData &&
    keikkaData.tila &&
    (keikkaData.tila.keikkaTilaSelite == "Toimitusvalmis" ||
    keikkaData.tila.keikkaTilaSelite == "Toimitus meneillään"
      ? 4
      : keikkaData.tila.keikkaTilaId);
  msg.keikkaId = keikkaData && keikkaData.keikkaId;
  msg.varmenne = keikkaData && keikkaData.varmenne;
  msg.stepLogTypeId = stepLogTypeId;
  msg.keikkaData = keikkaData && keikkaData.json && keikkaData.json();
  msg.data = data;
  return msg;
}

export function deleteMessage_not_used(keikkaId, stepLogId, socket) {
  socket.emit("stepLog:delete", stepLogId, keikkaId);
}
export function deleteStepLogMessagesByType(keikkaId, stepLogTypeId, socket) {
  socket.emit("stepLog:deleteType", stepLogTypeId, keikkaId);
}

export async function fetchStepLogMessageCount(keikkaId, token) {
  const a = await fetchAllStepLogMessages(keikkaId, token);
  let totCount = a.length;
  let msgCountForAsiakas = 0;
  let warnCount = 0;
  let unconfirmCount = 0;
  let confirmedCount = 0;
  let totalRequireCount = 0;
  for (let i = 0; i < totCount; i++) {
    const msg = a[i];
    if (!msg.isSystemMessage) msgCountForAsiakas++;
    if (msg.requireConfirm) {
      totalRequireCount++;
      if (msg.isConfirmed) {
        confirmedCount++;
      } else {
        unconfirmCount++;
      }
    } else if (msg.confirmCode != null) {
      if (msg.isConfirmed) {
        confirmedCount++;
      } else {
        warnCount++;
      }
    }
  }
  return {
    totCount,
    warnCount,
    unconfirmCount,
    confirmedCount,
    totalRequireCount,
    msgCountForAsiakas,
  };
}

export async function fetchAllStepLogMessages(keikkaId, token) {
  if (keikkaId == null) return null;
  if (keikkaId == 0) return null;

  const addr = "/api/stepLog/list/" + keikkaId;
  const response = await fetch(import.meta.env.VITE_SERVER_URL + addr, {
    method: "GET",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
  });
  const data = (await checkResponse(response, "stepLogMessageClass.fetchAllStepLogMessages")).data;
  if (data == null || data.length == 0) {
    return [];
    // NO stepLog MESSAGES FOUND!!
  } else {
    return data;
  }
}
